let baseUrl = '';

if (process.env.NODE_ENV === "production") {
    baseUrl = '';
} else if (process.env.NODE_ENV === "development") {
    baseUrl = 'http://localhost:8089'
}

export default baseUrl;